<template>
    <!-- @click is placed here because element button is removed from DOM before SearchTypeTable check if it's clickable, and it may cause event to bubble up -->
    <span>
        <button type="button" class="btn default btn-xs blue"
                v-tooltip
                title="Visualizar galeria"
                @click.prevent="showGallery"
                v-if="!loading && !disabled">
            <i class="fa fa-camera">
                {{label}}
            </i>

        </button>
        <button type="button" class="btn default btn-xs blue"
                v-tooltip
                title="Carregando..."
                v-if="loading && !disabled">
            <i class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <button type="button" class="btn default btn-xs disabled"
                v-tooltip
                title="Não há imagens nem vídeos"
                v-if="disabled">
            <i class="fa fa-camera">
                {{label}}
            </i>
        </button>
    </span>
</template>
<style scoped>
</style>
<script>
    const qs = require('qs')
    const urlparse = require('url-parse')
    const $ = require('jquery')
    const PhotoSwipe = require('photoswipe');
    const PhotoSwipeUI_Default = require('photoswipe/dist/photoswipe-ui-default');


    const searchClient = require('sci/helpers/search-client')
    const pswpTemplate = require('templates/components/pswp-element.html');

    let pswpElement = document.querySelector('.pswp')
    if (!pswpElement) {
        const newElement = document.createElement('div')
        newElement.className = "placeholder-element"
        newElement.innerHTML = pswpTemplate
        document.body.appendChild(newElement)
        pswpElement = newElement.firstChild;
    }

    export default {
        props: {
            propertyId: {
                type: Number,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            label: {
                required: false,
            }
        },
        data () {
            return {
                loading: false
            }
        },
        ready () {
            let pswpElement = null;
        },
        methods: {
            showGallery(evt) {
                evt.preventDefault()
                evt.stopPropagation()

                if (this.disabled || this.loading) {
                    return
                }
                
                this.loading = true
                searchClient
                    .query({
                        query: `query ($id: Long!) {
                            result: property(id: $id) {
                                id
                                photos {
                                    id
                                    position
                                    description
                                    name
                                    path
                                    mime
                                    size
                                    width
                                    height
                                    url
                                    thumbnails {
                                        wmedium
                                    }
                                }
                                videos {
                                    id
                                    url
                                    thumbnail
                                }
                            }
                        }`,
                        variables: {
                            id: this.propertyId
                        }
                    }).then((res) => {
                        this.loading = false

                        const property = res.data.result

                        let items = property.photos.map((photo) => {
                            return {
                                src: photo.url,
                                w: photo.width,
                                h: photo.height,
                                title: photo.description || photo.name
                            };
                        });

                        items = items.concat(property.videos.map((video) => {
                            const url = urlparse(video.url);
                            const querystring = qs.parse(url.query.replace(/^\?/, ''));
                            const code = querystring.v;
                            return {
                                html: `<iframe src="https://youtube.com.br/embed/${code}"></iframe>`
                            }
                        }));

                        const options = {
                            // history & focus options are disabled on CodePen
                            history: false,
                            arrowKeys: true,
                            closeOnScroll: false,
                            shareEl: false,
                            counterEl: false
                        };

                        const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                        gallery.init();
                    }).catch(() => {
                        this.loading = false
                    })
            }
        },
        computed: {}
    }
</script>



// WEBPACK FOOTER //
// MediaButton.vue?4e3c911e